// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.article-container{
    width: 100%;
    max-width: 1200px;

    height: 410px;

    margin-bottom: 1.7%;
    display: flex;
    justify-content: center;
    /*border: 1px solid blue;*/
}

.article-image-container{
    width: 50%;
    height: 100%;
    /*border: 1px solid green;*/
}

.article-image{
    width: 90%;
    min-width: 470px;
    max-width: 500px;
    height: 90%;

    margin: 10px 5%;
    /*border: 1px solid black;*/
}

.multi-image-container{
    width: 100%;
    height: 100% ;
    /*border: 1px solid aqua;*/
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.multi-image-main-image-container{
    width: 100%;
    min-width: 350px;
    max-width: 370px;
    height: 280px;
    margin-left: 15%;
    margin-right: 15%;
}

.multi-image-main-image{
    width: 100%;
    height: 100%;
}

.multi-image-slides-container{
    width: 100%;
    max-width: 500px;
    height: 110px;
    display: flex;
    justify-content: space-around;
    /*border: 1px solid black;*/
}

.multi-image-image-container{
    width: 25%;
    height: 100%;
}

.multi-image-image{
    width: 100%;
    height: 100%;
}

.article-text-container{
    width: 48%;
    margin-left: 1%;
    margin-right: 1%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.article-text-title{
    font-size: 2em;
    margin-bottom: 10px;
}

.article-text-description{
    font-size: 1.2em;
    margin-bottom: 6.5%;
}

.article-button{
    width: 100%;
    height: 40px;

    border-radius: 50px;

    font-size: 1.1em;
    font-weight: 750;
    color: #012D26;
    background-color: #E8DE00;

    border: none;
}

.article-line{
    width: 100%;
    height: 8px;
    background-color: #E8DE00;

}

@media only screen and (max-width: 1100px){
    .article-container{
        width: 100%;
        max-width: none;

        height: auto;

        margin-bottom: 50px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        /*border: 1px solid blue;*/
    }

    .article-image-container{
        display: flex;
        justify-content: center;
        width: 100%;
        height: 100%;
        /*border: 1px solid green;*/
    }

    .article-image{
        width: 90%;
        min-height: auto;
        max-height: none;
        min-width: auto;
        max-width: none;
        height: auto;

        margin: 10px 5%;
        /*border: 1px solid black;*/
    }

    .multi-image-container{
        width: 100%;
        height: 100% ;
        /*border: 1px solid aqua;*/
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin: 10px 0;
    }

    .multi-image-main-image-container{
        width: 45%;
        min-width: auto;
        max-width: none;
        height: auto;
        margin: 25px 0;
    }

    .multi-image-slides-container{
        height: auto;
    }

    .multi-image-image-container{
        width: 25%;
        height: 100%;
    }
    .article-text-container{
        width: 100%
    }
    .article-text-title{
        font-size: 1.3em;
        margin: 10px 0;
        text-align: center;
    }

    .article-text-description{
        font-size: 0.8em;
        margin-bottom: 6.5%;
    }

    .article-button{
        width: 100%;
        height: 30px;

        border-radius: 50px;

        font-size: 0.8em;
        font-weight: 750;
        color: #012D26;
        background-color: #E8DE00;

        border: none;
    }

    .article-line{
        width: 100%;
        height: 8px;
        background-color: #E8DE00;

    }
}

@media only screen and (max-width: 410px){
    .article-container{
        margin: 20px 0;
    }

    .multi-image-main-image-container{
        width: 80%;
        min-width: auto;
        max-width: none;
        height: auto;
        margin: 10px 0;
    }

    .multi-image-image-container{
        width: 20%;
    }

    .article-text-title{
        font-size: 1.2em;
        font-weight: bold;
        text-align: left;
    }

    .article-text-description{
        font-size: 0.7em;
    }

    .article-button{
        width: 100%;
        height: 20px;

        border-radius: 50px;

        font-size: 0.8em;
        font-weight: 750;
        color: #012D26;
        background-color: #E8DE00;
        border: none;
    }
}`, "",{"version":3,"sources":["webpack://./src/App/Component/Article/style.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,iBAAiB;;IAEjB,aAAa;;IAEb,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,0BAA0B;AAC9B;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,2BAA2B;AAC/B;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;;IAEX,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,0BAA0B;IAC1B,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,aAAa;IACb,6BAA6B;IAC7B,2BAA2B;AAC/B;;AAEA;IACI,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;;IAEZ,mBAAmB;;IAEnB,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,yBAAyB;;IAEzB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,yBAAyB;;AAE7B;;AAEA;IACI;QACI,WAAW;QACX,eAAe;;QAEf,YAAY;;QAEZ,mBAAmB;QACnB,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,0BAA0B;IAC9B;;IAEA;QACI,aAAa;QACb,uBAAuB;QACvB,WAAW;QACX,YAAY;QACZ,2BAA2B;IAC/B;;IAEA;QACI,UAAU;QACV,gBAAgB;QAChB,gBAAgB;QAChB,eAAe;QACf,eAAe;QACf,YAAY;;QAEZ,eAAe;QACf,2BAA2B;IAC/B;;IAEA;QACI,WAAW;QACX,aAAa;QACb,0BAA0B;QAC1B,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,uBAAuB;QACvB,cAAc;IAClB;;IAEA;QACI,UAAU;QACV,eAAe;QACf,eAAe;QACf,YAAY;QACZ,cAAc;IAClB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,UAAU;QACV,YAAY;IAChB;IACA;QACI;IACJ;IACA;QACI,gBAAgB;QAChB,cAAc;QACd,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,YAAY;;QAEZ,mBAAmB;;QAEnB,gBAAgB;QAChB,gBAAgB;QAChB,cAAc;QACd,yBAAyB;;QAEzB,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,WAAW;QACX,yBAAyB;;IAE7B;AACJ;;AAEA;IACI;QACI,cAAc;IAClB;;IAEA;QACI,UAAU;QACV,eAAe;QACf,eAAe;QACf,YAAY;QACZ,cAAc;IAClB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,YAAY;;QAEZ,mBAAmB;;QAEnB,gBAAgB;QAChB,gBAAgB;QAChB,cAAc;QACd,yBAAyB;QACzB,YAAY;IAChB;AACJ","sourcesContent":[".article-container{\r\n    width: 100%;\r\n    max-width: 1200px;\r\n\r\n    height: 410px;\r\n\r\n    margin-bottom: 1.7%;\r\n    display: flex;\r\n    justify-content: center;\r\n    /*border: 1px solid blue;*/\r\n}\r\n\r\n.article-image-container{\r\n    width: 50%;\r\n    height: 100%;\r\n    /*border: 1px solid green;*/\r\n}\r\n\r\n.article-image{\r\n    width: 90%;\r\n    min-width: 470px;\r\n    max-width: 500px;\r\n    height: 90%;\r\n\r\n    margin: 10px 5%;\r\n    /*border: 1px solid black;*/\r\n}\r\n\r\n.multi-image-container{\r\n    width: 100%;\r\n    height: 100% ;\r\n    /*border: 1px solid aqua;*/\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.multi-image-main-image-container{\r\n    width: 100%;\r\n    min-width: 350px;\r\n    max-width: 370px;\r\n    height: 280px;\r\n    margin-left: 15%;\r\n    margin-right: 15%;\r\n}\r\n\r\n.multi-image-main-image{\r\n    width: 100%;\r\n    height: 100%;\r\n}\r\n\r\n.multi-image-slides-container{\r\n    width: 100%;\r\n    max-width: 500px;\r\n    height: 110px;\r\n    display: flex;\r\n    justify-content: space-around;\r\n    /*border: 1px solid black;*/\r\n}\r\n\r\n.multi-image-image-container{\r\n    width: 25%;\r\n    height: 100%;\r\n}\r\n\r\n.multi-image-image{\r\n    width: 100%;\r\n    height: 100%;\r\n}\r\n\r\n.article-text-container{\r\n    width: 48%;\r\n    margin-left: 1%;\r\n    margin-right: 1%;\r\n    height: 100%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n}\r\n\r\n.article-text-title{\r\n    font-size: 2em;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.article-text-description{\r\n    font-size: 1.2em;\r\n    margin-bottom: 6.5%;\r\n}\r\n\r\n.article-button{\r\n    width: 100%;\r\n    height: 40px;\r\n\r\n    border-radius: 50px;\r\n\r\n    font-size: 1.1em;\r\n    font-weight: 750;\r\n    color: #012D26;\r\n    background-color: #E8DE00;\r\n\r\n    border: none;\r\n}\r\n\r\n.article-line{\r\n    width: 100%;\r\n    height: 8px;\r\n    background-color: #E8DE00;\r\n\r\n}\r\n\r\n@media only screen and (max-width: 1100px){\r\n    .article-container{\r\n        width: 100%;\r\n        max-width: none;\r\n\r\n        height: auto;\r\n\r\n        margin-bottom: 50px;\r\n        display: flex;\r\n        flex-direction: column;\r\n        justify-content: center;\r\n        /*border: 1px solid blue;*/\r\n    }\r\n\r\n    .article-image-container{\r\n        display: flex;\r\n        justify-content: center;\r\n        width: 100%;\r\n        height: 100%;\r\n        /*border: 1px solid green;*/\r\n    }\r\n\r\n    .article-image{\r\n        width: 90%;\r\n        min-height: auto;\r\n        max-height: none;\r\n        min-width: auto;\r\n        max-width: none;\r\n        height: auto;\r\n\r\n        margin: 10px 5%;\r\n        /*border: 1px solid black;*/\r\n    }\r\n\r\n    .multi-image-container{\r\n        width: 100%;\r\n        height: 100% ;\r\n        /*border: 1px solid aqua;*/\r\n        display: flex;\r\n        flex-direction: column;\r\n        align-items: center;\r\n        justify-content: center;\r\n        margin: 10px 0;\r\n    }\r\n\r\n    .multi-image-main-image-container{\r\n        width: 45%;\r\n        min-width: auto;\r\n        max-width: none;\r\n        height: auto;\r\n        margin: 25px 0;\r\n    }\r\n\r\n    .multi-image-slides-container{\r\n        height: auto;\r\n    }\r\n\r\n    .multi-image-image-container{\r\n        width: 25%;\r\n        height: 100%;\r\n    }\r\n    .article-text-container{\r\n        width: 100%\r\n    }\r\n    .article-text-title{\r\n        font-size: 1.3em;\r\n        margin: 10px 0;\r\n        text-align: center;\r\n    }\r\n\r\n    .article-text-description{\r\n        font-size: 0.8em;\r\n        margin-bottom: 6.5%;\r\n    }\r\n\r\n    .article-button{\r\n        width: 100%;\r\n        height: 30px;\r\n\r\n        border-radius: 50px;\r\n\r\n        font-size: 0.8em;\r\n        font-weight: 750;\r\n        color: #012D26;\r\n        background-color: #E8DE00;\r\n\r\n        border: none;\r\n    }\r\n\r\n    .article-line{\r\n        width: 100%;\r\n        height: 8px;\r\n        background-color: #E8DE00;\r\n\r\n    }\r\n}\r\n\r\n@media only screen and (max-width: 410px){\r\n    .article-container{\r\n        margin: 20px 0;\r\n    }\r\n\r\n    .multi-image-main-image-container{\r\n        width: 80%;\r\n        min-width: auto;\r\n        max-width: none;\r\n        height: auto;\r\n        margin: 10px 0;\r\n    }\r\n\r\n    .multi-image-image-container{\r\n        width: 20%;\r\n    }\r\n\r\n    .article-text-title{\r\n        font-size: 1.2em;\r\n        font-weight: bold;\r\n        text-align: left;\r\n    }\r\n\r\n    .article-text-description{\r\n        font-size: 0.7em;\r\n    }\r\n\r\n    .article-button{\r\n        width: 100%;\r\n        height: 20px;\r\n\r\n        border-radius: 50px;\r\n\r\n        font-size: 0.8em;\r\n        font-weight: 750;\r\n        color: #012D26;\r\n        background-color: #E8DE00;\r\n        border: none;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
